import { CyclicalDependencyError } from "./errors";
import { groupEvents, } from "./init/group-events";
import { listReactiveExpressions, } from "./init/list-reactive-expressions";
import { createKeyMaps, } from "./init/map-keys";
import { sortEvents } from "./init/sort-events";
import { sortExpressions } from "./init/sort-expressions";
import { getTermDependents } from "./init/term-dependents";
export class ReferenceTable {
    constructor(model) {
        var _a;
        this.model = model;
        const { keyToNode, nodeToKey, keyConflicts } = createKeyMaps(model);
        this.keyToNode = keyToNode;
        this.nodeToKey = nodeToKey;
        this.keyConflicts = keyConflicts;
        // Return a flat list of expressions, each expression will have a list of the dependencies
        // also return a way for an expression to reference another expression
        const [reactiveExpressions, expressionReference] = listReactiveExpressions(model);
        this.expressionReference = expressionReference;
        // Use a topographical sort algorithm to sor the expressions
        try {
            this.sortedReactiveExpressions = sortExpressions(reactiveExpressions, expressionReference);
        }
        catch (ex) {
            if (ex instanceof CyclicalDependencyError) {
                ex.message = `The expression for "${ex.nodeType}" contains a cyclical dependency in "${ex.iterableName ? ex.iterableName + "." + ex.termName : ex.termName}".`;
            }
            throw ex;
        }
        // For each term value, what expressions depend on it? Those are the dependents.
        this.termDependents = getTermDependents(this.sortedReactiveExpressions, expressionReference);
        const { onReadyEvents, onTermInputEvents, onIterableCountEvents, onActionEvents, eventSetReference, } = groupEvents(model);
        try {
            this.onReadyEvents = sortEvents(onReadyEvents, eventSetReference.onReady, expressionReference, true);
        }
        catch (ex) {
            if (ex instanceof CyclicalDependencyError) {
                ex.message = `The on READY events contain a cyclical dependency in "${ex.iterableName ? ex.iterableName + "." + ex.termName : ex.termName}".`;
            }
            throw ex;
        }
        this.onTermInputEvents = {
            terms: {},
            iterables: {},
        };
        for (const [termName, eventSets] of Object.entries(onTermInputEvents.terms)) {
            try {
                this.onTermInputEvents.terms[termName] = sortEvents(eventSets, eventSetReference.onTermInput.terms[termName], expressionReference);
            }
            catch (ex) {
                if (ex instanceof CyclicalDependencyError) {
                    ex.message = `The onTermInput events of "${termName}" contain a cyclical dependency in "${ex.iterableName ? ex.iterableName + "." + ex.termName : ex.termName}".`;
                }
                throw ex;
            }
        }
        for (const [iterableName, termEventSets] of Object.entries(onTermInputEvents.iterables)) {
            this.onTermInputEvents.iterables[iterableName] = {};
            for (const [termName, eventSets] of Object.entries(termEventSets)) {
                try {
                    this.onTermInputEvents.iterables[iterableName][termName] = sortEvents(eventSets, (_a = eventSetReference.onTermInput.iterables[iterableName]) === null || _a === void 0 ? void 0 : _a[termName], expressionReference);
                }
                catch (ex) {
                    if (ex instanceof CyclicalDependencyError) {
                        ex.message = `The onTermInput events of "${iterableName}/${termName}" contain a cyclical dependency in "${ex.iterableName
                            ? ex.iterableName + "." + ex.termName
                            : ex.termName}".`;
                    }
                    throw ex;
                }
            }
        }
        this.onIterableCountEvents = {};
        for (const [iterableName, eventSets] of Object.entries(onIterableCountEvents)) {
            try {
                this.onIterableCountEvents[iterableName] = sortEvents(eventSets, eventSetReference.onIterableCount[iterableName], expressionReference);
            }
            catch (ex) {
                if (ex instanceof CyclicalDependencyError) {
                    ex.message = `The onIterableCount events of "${iterableName}" contain a cyclical dependency in "${ex.iterableName ? ex.iterableName + "." + ex.termName : ex.termName}".`;
                }
                throw ex;
            }
        }
        this.onActionEvents = {};
        for (const [actionName, eventSets] of Object.entries(onActionEvents)) {
            try {
                this.onActionEvents[actionName] = sortEvents(eventSets, eventSetReference.onAction[actionName], expressionReference);
            }
            catch (ex) {
                if (ex instanceof CyclicalDependencyError) {
                    ex.message = `The onAction events of "${actionName}" contain a cyclical dependency in "${ex.iterableName ? ex.iterableName + "." + ex.termName : ex.termName}".`;
                }
                throw ex;
            }
        }
        this.eventSetReference = eventSetReference;
    }
}
//# sourceMappingURL=reference-table.js.map